var _defs, _g, _g2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSignUpVerification = function SvgSignUpVerification(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 565.09 406.29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cfdcff;}.cls-2{fill:#5e80e6;}.cls-3{opacity:0.3;}.cls-4{fill:#263238;}.cls-5{opacity:0.5;}.cls-6{fill:#fafafa;}.cls-7{fill:#aaedeb;}.cls-8{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    "data-name": "Background Simple"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.55,368.84c89.19.83,135-44.83,135-44.83,22.74-20.47,30.27-48,28-78.54-2.36-31.5-12.76-55.31-40.78-69.91s-62.18-15.53-92-5.17c-17.71,6.14-34.91,16.19-53.64,15.38-25.55-1.09-45.81-22.12-58.78-44.16s-21.94-46.91-39.51-65.5c-24.57-26-65.11-35.43-98.63-23s-58.85,42.33-66,78.44c0,0-14.73,48.93,20.24,116.08C153.7,388.36,346.55,368.84,346.55,368.84Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Message"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "163.19 181.82 399.06 180.11 405.64 340.47 161.4 338.21 163.19 181.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.19,181.82,274.82,91.5a12.82,12.82,0,0,1,16.2,0l108,88.56"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.19,181.82,274.82,91.5a12.82,12.82,0,0,1,16.2,0l108,88.56"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.4,338.21c-.29-.28,18.59-20.89,42.17-46s43-45.33,43.24-45.05-18.58,20.88-42.17,46S161.7,338.49,161.4,338.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M405.64,340.47c-.3.27-18.69-19.93-41.07-45.11s-40.28-45.82-40-46.09,18.68,19.93,41.07,45.12S405.94,340.21,405.64,340.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "399.06 180.11 280.62 274.73 163.19 181.82"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.07 190.59 174.7 116.92 381.24 114.48 383.56 191.99 280.61 273.49 175.07 190.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.07,190.59s.67.5,1.94,1.48l5.6,4.37,21.31,16.66,76.82,60.22h-.26l102.93-81.53-.1.21c-.45-14.79-.91-30.3-1.39-46.09-.32-10.63-.63-21.13-.94-31.43l.26.26L174.7,117.09l.17-.17c.08,23.18.14,41.58.19,54.2,0,6.31,0,11.17,0,14.46v3.73c0,.84,0,1.28,0,1.28s0-.42,0-1.26,0-2.08,0-3.71c0-3.29-.06-8.14-.11-14.44-.08-12.63-.2-31.06-.35-54.26v-.17h.17l206.53-2.53h.26v.26c.31,10.29.62,20.8.94,31.42.47,15.79.94,31.3,1.38,46.09v.13l-.1.08-103,81.47-.13.1-.13-.1-76.76-60.42L182.5,196.49,177,192.1C175.7,191.11,175.07,190.59,175.07,190.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M348.6,151.57c0,.14-31.59.45-70.54.69s-70.55.31-70.55.16,31.58-.45,70.54-.68S348.6,151.42,348.6,151.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M348.6,172.38c0,.14-31.59.45-70.54.69s-70.55.31-70.55.16,31.58-.45,70.54-.69S348.6,172.23,348.6,172.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M348.6,196.36c0,.14-31.59.45-70.54.69s-70.55.31-70.55.17,31.58-.46,70.54-.69S348.6,196.22,348.6,196.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M348.6,220.34c0,.15-30.14.45-67.3.67s-67.31.29-67.31.15,30.13-.44,67.31-.67S348.6,220.2,348.6,220.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M322.18,241.4a7.54,7.54,0,0,1-.83,0l-2.37.07-8.73.14-28.78.41c-11.25.19-21.43.26-28.8.26l-8.73,0-2.37,0a4.16,4.16,0,0,1-.83-.05,7.83,7.83,0,0,1,.83,0l2.37-.07,8.73-.14,28.79-.42c11.24-.18,21.42-.25,28.79-.26l8.73,0,2.37,0A4.06,4.06,0,0,1,322.18,241.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M295.59,261.63c0,.14-6.73.26-15,.26s-15-.12-15-.26,6.73-.26,15-.26S295.59,261.49,295.59,261.63Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 361.96,
    cy: 220.27,
    r: 24.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M386.17,220.27A24.27,24.27,0,0,1,362,244.47a23.85,23.85,0,0,1-18.91-9.07,23.94,23.94,0,0,0,15.13,5.29,24.28,24.28,0,0,0,24.21-24.2,23.87,23.87,0,0,0-5.3-15.13A23.8,23.8,0,0,1,386.17,220.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M375.13,213.31l-15.74,17.25a2.58,2.58,0,0,1-3.93,0l-6.66-7.42a2.67,2.67,0,1,1,3.93-3.63l4.69,5.3,13.77-15a2.65,2.65,0,0,1,3.78-.15A2.61,2.61,0,0,1,375.13,213.31Z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignUpVerification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SignUp_Verification.4985e8ec.svg";
export { ForwardRef as ReactComponent };